import configuration from "../config";
import axios from "./axiosConfiguration";

const endpoint = `${configuration.api_url}audit-data`;

export const getAuditDatas = () => {
    return axios
        .get(endpoint)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const saveAuditData = async (data) => {
    return axios
        .post(`${endpoint}`, data)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const deleteAuditData = async (blocId) => {
    return axios
        .delete(`${endpoint}/${blocId}`)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};
